import { render } from "./CoolerP5Comp.vue?vue&type=template&id=2f968e1e&scoped=true"
import script from "./CoolerP5Comp.vue?vue&type=script&lang=js"
export * from "./CoolerP5Comp.vue?vue&type=script&lang=js"

import "./CoolerP5Comp.vue?vue&type=style&index=0&id=2f968e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f968e1e"]])

export default __exports__